// Function to show the popup (from previous request)
function showPopup() {
    console.log("showPopup");
  const popupOverlay = document.querySelector('.popup-overlay');
  if (popupOverlay) {
    popupOverlay.style.display = 'flex';
  }
}

// Function to hide the popup
function hidePopup() {
     console.log("hidePopup");
  const popupOverlay = document.querySelector('.popup-overlay');
  if (popupOverlay) {
    popupOverlay.style.display = 'none';
  }
}

// Function to handle the closing logic
function setupPopupCloseHandlers() {
  const popupOverlay = document.querySelector('.popup-overlay');
  const closeButton = document.querySelector('.popup-close-button');
  const submitButton = document.querySelector('.submit-button');

  if (!popupOverlay) return;

  // 1. Close on Close Button click (.close-button)
  if (closeButton) {
    closeButton.addEventListener('click', hidePopup);
  }


  if (submitButton) {
    submitButton.addEventListener('click', (e) => {
      hidePopup();
    });
  }


  popupOverlay.addEventListener('click', (e) => {
    if (e.target === e.currentTarget) {
      hidePopup();
    }
  });
}


// --- INITIALIZATION ---
document.addEventListener('DOMContentLoaded', () => {
  const contentElement = document.querySelector('.content');
  const flagElement = document.querySelector('.flag');
  

  if (contentElement) {
    contentElement.addEventListener('click', showPopup);
  }
  if (flagElement) {
    flagElement.addEventListener('click', showPopup);
  }


  setupPopupCloseHandlers();
});